import { JsonObject, JsonProperty } from 'json2typescript';
import { Station } from './station';
import { FixedCode } from './fixed-code';

//** Detail spoje s jízdním řádem, případně i trasou * /
@JsonObject("ConnectionDetail")
export class ConnectionDetail {
  @JsonProperty('id', String)
  id: string = "";
  @JsonProperty('name', String)
  name: string = ""
  @JsonProperty('detour', Number, true)
  detour: number | undefined = undefined
  @JsonProperty('operator', String)
  operator: string = ""
  @JsonProperty('distance', Number)
  distance: number = 0;
  @JsonProperty('durationHours', Number)
  durationHours: number = 0
  @JsonProperty('durationMinutes', Number)
  durationMinutes: number = 0;
  @JsonProperty('vehicleType', String)
  vehicleType: string = 'A' // V vlak
  @JsonProperty('sourceType', String, true)
  sourceType: string | undefined = undefined
  @JsonProperty('lineType', String, true)
  lineType: string | undefined = undefined   // nechodí u vlaků, A je MHD
  @JsonProperty('geometry', String, true)
  geometry: string | undefined = undefined
  @JsonProperty('zones', [Number])
  zones: number[] = []
  @JsonProperty('stations', [Station])
  stations: Station[] = []
  @JsonProperty('fixedCodes', [Array<FixedCode>], true)
  fixedCodes: FixedCode[] = []
  @JsonProperty('extLineName', String, true)
  extLineName: string | undefined = undefined

  dep(): string {
    if (this.stations.length > 0)
      return this.stations[0].name
    else
      return '';
  }

  dest(): string {
    if (this.stations.length > 0)
      return this.stations[this.stations.length - 1].name
    else
      return '';
  }

  depTime(): string {
    if (this.stations.length > 0)
      return this.stations[0].departureTime ?? ""
    else
      return '';
  }

  destTime(): string {
    if (this.stations.length > 0)
      return this.stations[this.stations.length - 1].arrivalTime ?? ""
    else
      return '';
  }

  depPlatform(): string {
    if (this.stations.length > 0)
      return this.stations[0].platform ?? ""
    else
      return '';
  }

  destPlatform(): string {
    if (this.stations.length > 0)
      return this.stations[this.stations.length - 1].platform ?? ""
    else
      return '';
  }

  iconClass(): string {
    if (this.vehicleType == 'V')
      return 'K';
    else if (this.lineType === 'A')
      return 'M';
      
    return 'S';
  }
}
